<!--suppress AngularNgOptimizedImage-->
@if (!(themeService.selectedTheme?.class)) {
  <div class="logo-container logo-t4f-container">
    <img class="bracket" src="logos/t4f-left.png" [alt]="'[' | translate">
    <img class="title" src="logos/t4f.png" [alt]="'Twict4Fiber' | translate">
    <img class="bracket" src="logos/t4f-right.png" [alt]="']' | translate">
  </div>
}

@if (themeService.selectedTheme?.class === 'theme-dark') {
  <div class="logo-container logo-t4f-container">
    <img class="bracket" src="logos/t4f-left.png" [alt]="'[' | translate">
    <img class="title" src="logos/t4f.png" [alt]="'Twict4Fiber' | translate">
    <img class="bracket" src="logos/t4f-right.png" [alt]="']' | translate">
  </div>
}

@if (themeService.selectedTheme?.class === 'theme-bam') {
  <div class="logo-container">
    <img class="title" src="logos/bam.png" [alt]="'BAM Telecom'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}

@if (themeService.selectedTheme?.class === 'theme-art') {
  <div class="logo-container">
    <img class="title" src="logos/art.png" [alt]="'Artemis ITS'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}

@if (themeService.selectedTheme?.class === 'theme-s30') {
  <div class="logo-container">
    <img class="title" src="logos/s30.png" [alt]="'Solutions30'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}

@if (themeService.selectedTheme?.class === 'theme-fcop') {
  <div class="logo-container">
    <img class="title" src="logos/fcop-white.png" [alt]="'FiberCop'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}

@if (themeService.selectedTheme?.class === 'theme-baas') {
  <div class="logo-container">
    <img class="title" src="logos/baas.png" [alt]="'Baas'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}

@if (themeService.selectedTheme?.class === 'theme-vwtd') {
  <div class="logo-container">
    <img class="title" src="logos/vwtd.svg" [alt]="'VolkerWessels Telecom Deutschland'">
  </div>
  <app-animated-container>
    @if (brandingLayoutService.hideSubtitle !== true) {
      <div class="subtitle">
        <small>{{'Powered by Twict4Fiber' | translate}}</small>
      </div>
    }
  </app-animated-container>
}
